<template>
    <div class="listmain ">
        <h1 class="firTitle">智能硬件平台简介</h1>
              <p>OrionOS智能设备开放平台将猎户语音全链路能力完全开放，智能硬件厂商可通过OS接入，迅速搭建智能设备语音交互能力。通过云端配置，可接入海量有声内容和语音交互技能。查天气，设闹钟，听歌，家居控制应有尽有。
              </p>
              <h3 class="sedTitle">硬件产品创建</h3>

              <h3 class="sedTitle">1.登陆开放平台</h3>
              <p>未注册请立即注册，已注册立即登陆
              </p>
              <h3 class="sedTitle">2.开发者认证</h3>
              <p>开发者可以通过OrionOS硬件接入集成语音交互引擎，在产品集成SDK前需要经过开发者认证并通过审核后才能使用。
                <br> 提交个人或企业基本信息认证开发者身份。开放平台运营中心会尽快将审核结果同步到消息中心，审核通过后，即可接入语音交互引擎
              </p>

              <h3 class="sedTitle">3.创建产品</h3>
              <p>填写产品基本信息，获取产品id以及产品secret
              </p>

              <h3 class="sedTitle">4.配置云端技能</h3>
              <p>
               开发者可以通过技能商店添加语音交互技能，为智能设备创造更丰富的交互能力
              </p>
               <h3 class="sedTitle">5.集成SDK</h3>
              <p>
                硬件接入SDK
                <a @click="topHome()" class="jc" style="cursor:pointer">
        查看文档
        </a>
                <br> 硬件接入SDK-Demo 查看文档  <router-link to='/tutor/ASDK' class="jc">
        查看文档
        </router-link>
                <br> 移动端语音伴侣（Android）  <router-link to='/tutor/access' class="jc">
        查看文档
        </router-link>
                <br> 移动端语音伴侣（iOS）  <router-link to='/tutor/env' class="jc">
        查看文档
        </router-link>
              </p>

    </div>
</template>

<script>
export default {
  name: "",
  methods:{
    topHome(){
      $('html,body').animate({scrollTop:0},200);
    }
  }
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 26px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>




// WEBPACK FOOTER //
// src/components/tutor/yjjrgl.vue